function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
export { _isNativeReflectConstruct as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
// module id = 236
// module chunks = 0